import { defaultTranslations } from 'breadcrumbs-ui/lang';

/** @deprecated Use `defaultTranslations` from `breadcrumbs-ui/lang` instead. */
export const defaultValues = defaultTranslations;

/** @deprecated Use `TranslationKey` from `breadcrumbs-ui/lang` instead. */